var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-gradient-to-r from-sky-200 to-blue-200 px-4 py-5 flex flex-row justify-between items-center"},[_c('h1',{staticClass:"text-xl"},[_vm._v(_vm._s(_vm.$t('title')))]),_c('LocaleSwitcher')],1)}
var staticRenderFns = []

export { render, staticRenderFns }